import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// detect languge
const defaultLanguge = document.getElementsByTagName('html')[0].getAttribute('lang')
const detected = (navigator.language || navigator.userLanguage).substr(0, 2)
const userLanguage = document.getElementsByTagName('html')[0].getAttribute('data-lang')
let locale
if(userLanguage) {
  locale = userLanguage
}
else {
  /*if(detected != defaultLanguge && ['pl', 'en'].indexOf(detected) >= 0) {
    document.location = '/locale/'+detected
    locale = detected
  }
  else*/ locale = defaultLanguge
}

locale = 'pl'

// const en = require('json-loader!yaml-loader!./en.yml')
const pl = require('json-loader!yaml-loader!./pl.yml')

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'pl',
  messages: { pl/*, en*/ },
})

export default i18n